import React from 'react';
import { useListHeaderStyles } from './style';

type ListHeaderProps = {
    children: React.ReactNode,
};

function ListHeader(props: ListHeaderProps): React.ReactElement {
    const { children } = props;
    const classes = useListHeaderStyles();

    return (
        <div className={classes.header}>
            {children}
        </div>
    );
}

export { ListHeader };
